<template>
  <v-autocomplete
    v-model="SELECIONADOS"
    :label="label_props"
    :dense="dense_props"
    :items="items_props"
    item-value="id"
    item-text="descricao"
    hide-details
    clearable
    outlined
    multiple
    small-chips
  >
    <template #prepend-item>
      <SysItemListaSelecionaTudo
        v-model="SELECIONADOS"
        :itens="items_props"
        valor-chave="id"
      />
      <v-divider />
    </template>

    <template #selection="{item}">
      <TextoOutrosFiltrosSelecionadosAutocomplete :filtros="SELECIONADOS" :item="item" retornar_texto_completo />
    </template>
  </v-autocomplete>
</template>

<script>
import SysItemListaSelecionaTudo from "@/components/utils/crud/SysItemListaSelecionaTudo.vue";
import TextoOutrosFiltrosSelecionadosAutocomplete from "@/components/Diagnostico/utils/TextoOutrosFiltrosSelecionadosAutocomplete.vue";

export default {
  name: "SysStatusProduto",
  components: {TextoOutrosFiltrosSelecionadosAutocomplete, SysItemListaSelecionaTudo},
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: ["modelValue", 'items_props', 'label_props', 'dense_props'],
  computed: {
    SELECIONADOS: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit("update:modelValue", valor)
      }
    }
  }
}
</script>

<style scoped>

</style>
